import { render } from "./DayReview.vue?vue&type=template&id=452a2c58&scoped=true"
import script from "./DayReview.vue?vue&type=script&lang=js"
export * from "./DayReview.vue?vue&type=script&lang=js"

import "./DayReview.vue?vue&type=style&index=0&id=452a2c58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452a2c58"]])

export default __exports__